export default __webpack_public_path__ + "static/media/hero.a084eef7.svg";